var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fillable",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C7.74154 5 4.0301 8.47154 2.06811 11.9274L2 12.0474L2.06811 12.1674C4.0301 15.6233 7.74154 19.0948 12 19.0948C16.2585 19.0948 19.9699 15.6233 21.9319 12.1674L22 12.0474L21.9319 11.9274C19.9699 8.47154 16.2585 5 12 5ZM12 17.6367C8.73111 17.6367 5.604 15.0671 3.69577 12.0474C5.604 9.02775 8.73111 6.45808 12 6.45808C15.2689 6.45808 18.396 9.02775 20.3042 12.0474C18.396 15.0671 15.2689 17.6367 12 17.6367ZM12 8.88822C10.2552 8.88822 8.84082 10.3026 8.84082 12.0474C8.84082 13.7922 10.2552 15.2066 12 15.2066C13.7448 15.2066 15.1592 13.7922 15.1592 12.0474C15.1592 10.3026 13.7448 8.88822 12 8.88822ZM10.2989 12.0474C10.2989 11.1079 11.0605 10.3463 12 10.3463C12.9395 10.3463 13.7011 11.1079 13.7011 12.0474C13.7011 12.9869 12.9395 13.7485 12 13.7485C11.0605 13.7485 10.2989 12.9869 10.2989 12.0474Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeIcon);
export default __webpack_public_path__ + "static/media/seeIcon.e492cdc8cfa759549839d5f45b327e26.svg";
export { ForwardRef as ReactComponent };